import React, { useEffect, useState } from "react";
import VestingPlanTable from "../NewEmployeeVestingReportContainer/VestingPlanTable";
import moment from "moment";
import {
  ManageEligibilityLayout,
  CsplTable as Table,
} from "../../../components";
import {
  MANAGE_ELIGIBILITY_ROUTES,
  getParamsFromQueryString,
} from "../../../utils";
import { getEmployeeVestingReport } from "../../../services";
import { CSVLink } from "react-csv";

const columns = [
  {
    label: "Company Name",
    className: "column-companyName",
    columnName: "companyName",
  },
  {
    label: "Plan ID",
    className: "column-planId",
    columnName: "planID",
  },
  {
    label: "Plan name",
    className: "column-planName",
    columnName: "planName",
  },
  {
    label: "Participants Eligible for Plan",
    className: "column-statusPlan",
    columnName: "statusForPlan",
  },
  {
    label: "Process Date",
    className: "column-processDate",
    columnName: "processDate",
  },
];

const NewEmployeeVestingReport = (props) => {
  const [isMockLoading, setIsLoading] = useState(false);
  const [vestingSummaryReportData, setVestingSummaryReportData] = useState([]);
  const planId = parseInt(getParamsFromQueryString("planId"));
  const processId = parseInt(getParamsFromQueryString("processId"));

  useEffect(() => {
    getEmployeeVestingReport(processId, planId)
      .then((response) => {
        setVestingSummaryReportData(response.vestingSummaryReportData);
      })
      .catch((error) => {});
  }, [planId]);

  const mockLoading = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const handleSortForGenericTable = (detail) => {
    mockLoading();
  };

  const scrollEndCallBack = () => {
    mockLoading();
  };

  const buttons = [
    {
      link: MANAGE_ELIGIBILITY_ROUTES.VESTING_SUMMARY_REPORTS,
      label: "Close",
      variant: "secondary",
      type: "button",
    },
  ];

  return (
    <ManageEligibilityLayout buttons={buttons}>
      <div className="eligibility-container marg-right-100">
        <CSVLink
          data={vestingSummaryReportData?.employeeVestingDetailReportData ?? []}
        >
          <p className="ft-18 fw-400">Export</p>
        </CSVLink>
      </div>
      <div className="w-100 new-employee-vesting-report">
        <div className="d-flex w-100 align-items-center justify-content-between mb-4">
          <div className="m-0 plan-heading font-weight-500">
            New Employee Vesting Report
          </div>
        </div>
        <Table>
          <Table.Thead>
            <Table.Tr>
              {columns.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td className="column-companyName">
                {vestingSummaryReportData?.companyName}
              </Table.Td>
              <Table.Td className="column-planId">
                {vestingSummaryReportData?.rkPlanNumber}
              </Table.Td>
              <Table.Td className="column-planName">
                {vestingSummaryReportData?.planName}
              </Table.Td>
              <Table.Td className="column-statusPlan">
                {vestingSummaryReportData?.employeeCount}
              </Table.Td>

              <Table.Td className="column-processDate">
                {moment(new Date(vestingSummaryReportData?.processDate)).format(
                  "MM-DD-YYYY"
                ) +
                  " " +
                  moment(
                    new Date(vestingSummaryReportData?.processDate)
                  ).format("HH:mm:ss")}
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </div>

      <div className="text-right mr-2 mb-10">
        <p>
          {vestingSummaryReportData?.employeeVestingDetailReportData?.length ??
            0}
          records
        </p>
      </div>
      <VestingPlanTable
        data={vestingSummaryReportData?.employeeVestingDetailReportData}
        isLoading={isMockLoading}
        handleSort={handleSortForGenericTable}
        scrollEndCallBack={scrollEndCallBack}
      />
    </ManageEligibilityLayout>
  );
};

export default NewEmployeeVestingReport;
